import { HayDayItems } from '../models/haydayitem';
export var Post = (function () {
    function Post() {
        this.created = firebase.database['ServerValue']['TIMESTAMP'];
    }
    Object.defineProperty(Post.prototype, "lookingForItem", {
        get: function () {
            if (!this._lookingForItem) {
                this._lookingForItem = HayDayItems.getItemById(this.lookingFor);
            }
            return this._lookingForItem;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Post.prototype, "sellingItem", {
        get: function () {
            if (!this._sellingItem) {
                this._sellingItem = HayDayItems.getItemById(this.selling);
            }
            return this._sellingItem;
        },
        enumerable: true,
        configurable: true
    });
    Post.create = function (obj) {
        var post = new Post();
        if (obj) {
            if (obj.hasOwnProperty("lookingFor")) {
                post.lookingFor = obj.lookingFor;
            }
            if (obj.hasOwnProperty("selling")) {
                post.selling = obj.selling;
            }
            if (obj.hasOwnProperty("created")) {
                post.created = obj.created;
            }
            if (obj.hasOwnProperty("expires")) {
                post.expires = obj.expires;
            }
            if (obj.hasOwnProperty("owner")) {
                post.owner = obj.owner;
            }
            if (obj.hasOwnProperty("lookingCount")) {
                post.lookingCount = obj.lookingCount;
            }
            if (obj.hasOwnProperty("sellingCount")) {
                post.sellingCount = obj.sellingCount;
            }
            if (obj.hasOwnProperty("$key")) {
                post.$key = obj.$key;
            }
            if (obj.hasOwnProperty("traderCount")) {
                post.traderCount = obj.traders;
            }
            if (obj.hasOwnProperty("state")) {
                post.state = obj.state;
            }
            if (obj.hasOwnProperty("traderId")) {
                post.traderId = obj.traderId;
            }
            if (obj.hasOwnProperty("authorResult")) {
                post.authorResult = obj.authorResult;
            }
            if (obj.hasOwnProperty("traderResult")) {
                post.traderResult = obj.traderResult;
            }
            if (obj.hasOwnProperty("searchStateLF")) {
                post.searchStateLF = obj.searchStateLF;
            }
            if (obj.hasOwnProperty("searchStateS")) {
                post.searchStateS = obj.searchStateS;
            }
            if (obj.hasOwnProperty("searchStateLS")) {
                post.searchStateLS = obj.searchStateLS;
            }
            if (obj.hasOwnProperty("hidden")) {
                post.hidden = obj.hidden;
            }
        }
        return post;
    };
    return Post;
}());
export var PostStates;
(function (PostStates) {
    PostStates[PostStates["Open"] = 0] = "Open";
    PostStates[PostStates["InviteSent"] = 1] = "InviteSent";
    PostStates[PostStates["InTrade"] = 2] = "InTrade";
    PostStates[PostStates["TradeComplete"] = 3] = "TradeComplete";
    PostStates[PostStates["Expired"] = 4] = "Expired";
    PostStates[PostStates["Full"] = 5] = "Full";
})(PostStates || (PostStates = {}));
export var PostResults;
(function (PostResults) {
    PostResults[PostResults["None"] = 0] = "None";
    PostResults[PostResults["Success"] = 1] = "Success";
    PostResults[PostResults["Abandoned"] = 2] = "Abandoned";
    PostResults[PostResults["Scammed"] = 3] = "Scammed";
})(PostResults || (PostResults = {}));
